<template>
    <div>
        <webix-ui :config="config" v-model="locations"></webix-ui>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
export default {
    data:() => ({
        clickedAction: false,
        config:{
            id: 'locationsTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'name', header:'Location Name', fillspace: true},
                { id: 'sqm', header:'Size', fillspace: 0.4},
                { id: 'actions', header:'Actions', fillspace: 0.2,  template: function(){
                    let element = `<div><i title="View comment" class="webix_icon_hover webix_icon edit_icon fas fa-pen"></i>&nbsp; &nbsp; &nbsp;<i title="View comment" class="webix_icon_hover webix_icon delete_icon fas fa-trash"></i></div>`;

                    return element;
                }}
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.$eventHub.$emit('editLocation', id.row);
                        }
                    }, 50)
                    
                }
            },
            onClick:{
                //eslint-disable-next-line
                edit_icon(event, cell, target){
                    var el = this.$scope.$parent;
                    el.clickedAction = true;
                    setTimeout(()=> {el.clickedAction = false;} , 150)
                    /*alert('Edit')*/
                },

            }
        },
    }),
    computed:{
        ...facilityAdminState,
        locations(){
            let data = [];
            if(this.client_locations != null){
                data = this.client_locations
            }
            return data;
        },
    },
    methods:{
        ...facilityAdminMethods,
    },
    mounted(){
        
    },
}
</script>

<style>

</style>